import "./PasswordReset.css"

import { useCallback, useRef, useState } from "react"
import { ReactComponent as Logo } from "./assets/logo.svg"
import { sendPasswordResetEmail } from "firebase/auth"
import { fbAuth } from "./firebase"

type State =
  | { type: "initialized" }
  | { type: "submitting" }
  | { type: "error"; error: unknown }
  | { type: "submitted" }

export default function PasswordReset() {
  const [state, setState] = useState<State>({ type: "initialized" })
  const emailInput = useRef<HTMLInputElement>(null)

  const onSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault()

      try {
        if (state.type === "submitting") {
          return
        }

        const email = emailInput.current?.value

        if (email) {
          setState({ type: "submitting" })
          const { protocol, host } = window.location
          await sendPasswordResetEmail(fbAuth, email, {
            url: `${protocol}//${host}`,
            handleCodeInApp: false,
          })
          setState({ type: "submitted" })
        }
      } catch (error) {
        console.error(error)
        setState({ type: "error", error })
      }
    },
    [state.type],
  )

  return (
    <div id="password-reset">
      <div className="content">
        <Logo className="logo" />

        {state.type === "submitted" ? (
          <div className="submitted">
            <p>
              Er is een link naar je e-mail gestuurd. Open deze link om een
              nieuw wachtwoord te kiezen.
            </p>
          </div>
        ) : (
          <>
            <p>
              Hier kun je een nieuw wachtwoord aanvragen voor de app van De
              slimste mens. Vul je e-mailadres in dat bij je account hoort.
            </p>

            <form onSubmit={onSubmit}>
              <div className="fields">
                <div className="field">
                  <label htmlFor="email">E-mailadres</label>
                  <input id="email" ref={emailInput} type="email" required />
                </div>
              </div>

              {state.type === "error" && (
                <div className="error">
                  <p>{formatError(state.error)}</p>
                </div>
              )}

              <button type="submit" disabled={state.type === "submitting"}>
                {state.type === "submitting" ? "Een moment..." : "Versturen"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  )
}

function formatError(error: unknown): string {
  if (error instanceof Error) {
    if (error.message.includes("auth/invalid-email")) {
      return "Het e-mailadres die je hebt ingevuld klopt niet."
    } else if (error.message.includes("auth/user-disabled")) {
      return "Het is niet mogelijk om een nieuw wachtwoord te maken voor dit account."
    }
  }
  return "Er is iets misgegaan, probeer het opnieuw of neem contact op met de helpdesk."
}
